export const getImageUrl = (column) => {
  return column?.its_an_image ? column?.image_data?.url : ''
}
